import React from "react";
import classes from "./FAQs.module.scss";
import Accordion from "../../UI/Accordion/Accordion";

interface FAQPoint {
  id: number;
  title: string;
  description: string;
}

interface FAQData {
  id?: number;
  title?: string | null;
  subTitle1?: string | null;
  subTitle2?: string | null;
  subTitle3?: string | null;
  sectionBgColor?: string | null;
  description?: string | null;
  faqPoints?: FAQPoint[];
}

interface FAQsProps {
  faqData?: FAQData;
}

const FAQs: React.FC<FAQsProps> = ({ faqData }) => {
  const accordionItems = (faqData?.faqPoints ?? []).map((faq) => ({
    title: faq.title,
    description: <div dangerouslySetInnerHTML={{ __html: faq.description }}></div>,
  }));

  if (!faqData || accordionItems.length === 0) return null;

  return (
    <section className={classes["faq-section"]}>
      <div className={classes["faq-container"]}>
        <h2 className={classes["faq-heading"]}>{faqData?.title ?? ""}</h2>
        {faqData?.description && <div className={classes["faq-subtext"]} dangerouslySetInnerHTML={{ __html: faqData?.description ?? "" }}></div>}

        <Accordion items={accordionItems} defaultOpenIndex={0} theme="base" icon="plus" />
      </div>
    </section>
  );
};

export default FAQs;
